// src/components/LocationPrompt.ts
import "./LocationPrompt.css";

export function renderLocationPrompt(
  container: HTMLElement,
  onDone: () => void,
) {
  container.innerHTML = `
    <div class="location-popup">
      <div class="location-box">
        <h3>Allow Location?</h3>
        <p>We use your location to show accurate weather.</p>

        <button id="loc-allow">Allow</button>
        <button id="loc-deny">Deny</button>
      </div>
    </div>
  `;

  document.getElementById("loc-allow")!.onclick = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const loc = `${latitude},${longitude}`;
        localStorage.setItem("ayesearch_user_location", loc);
        onDone();
      },
      () => {
        alert("Unable to get location.");
        onDone();
      },
    );
  };

  document.getElementById("loc-deny")!.onclick = () => {
    onDone();
  };
}
